import { ImageCropperConfig } from "@modules/shared/components/commons/image-cropper/models";

export interface CropImageInitData {
    imageUrl: string;
    options?: Partial<ImageCropperConfig>;
}